var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatbox1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 291,
    viewBox: "0 0 618 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1846_1237",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.603 0C607.077 0 618 10.923 618 24.3972V266.603C618 280.077 607.077 291 593.603 291H55.2717C46.8414 291 39.4099 286.724 35.0277 280.222H0.756592L21.4248 254.625L30.8762 242.19V24.3955C30.8762 10.9222 41.7985 0 55.2718 0H593.603Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593.603 0C607.077 0 618 10.923 618 24.3972V266.603C618 280.077 607.077 291 593.603 291H55.2717C46.8414 291 39.4099 286.724 35.0277 280.222H0.756592L21.4248 254.625L30.8762 242.19V24.3955C30.8762 10.9222 41.7985 0 55.2718 0H593.603Z",
    fill: "#D9D9D9",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0277 280.222V279.781H35.2621L35.3932 279.976L35.0277 280.222ZM0.756592 280.222V280.663H-0.165833L0.413635 279.945L0.756592 280.222ZM21.4248 254.625L21.7759 254.892L21.7678 254.902L21.4248 254.625ZM30.8762 242.19H31.317V242.338L31.2272 242.456L30.8762 242.19ZM617.559 24.3972C617.559 11.1664 606.834 0.440777 593.603 0.440777V-0.440777C607.32 -0.440777 618.441 10.6796 618.441 24.3972H617.559ZM617.559 266.603V24.3972H618.441V266.603H617.559ZM593.603 290.559C606.834 290.559 617.559 279.834 617.559 266.603H618.441C618.441 280.32 607.32 291.441 593.603 291.441V290.559ZM55.2717 290.559H593.603V291.441H55.2717V290.559ZM35.3932 279.976C39.6969 286.361 46.9941 290.559 55.2717 290.559V291.441C46.6887 291.441 39.1228 287.087 34.6622 280.469L35.3932 279.976ZM0.756592 279.781H35.0277V280.663H0.756592V279.781ZM21.7678 254.902L1.09955 280.499L0.413635 279.945L21.0818 254.348L21.7678 254.902ZM31.2272 242.456L21.7758 254.892L21.0739 254.358L30.5253 241.923L31.2272 242.456ZM31.317 24.3955V242.19H30.4354V24.3955H31.317ZM55.2718 0.440777C42.0419 0.440777 31.317 11.1657 31.317 24.3955H30.4354C30.4354 10.6788 41.5551 -0.440777 55.2718 -0.440777V0.440777ZM593.603 0.440777H55.2718V-0.440777H593.603V0.440777Z",
    fill: "#93B1A6",
    mask: "url(#path-1-inside-1_1846_1237)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbox1);
export default __webpack_public_path__ + "static/media/chatbox1.8a33a9c4c922f41af1748162e393c3e7.svg";
export { ForwardRef as ReactComponent };